<template>
  <div>
    <van-dropdown-menu>
      <van-dropdown-item title="我的城市" v-model="cityId" :options="citys" @change="changeCity()" />
      <van-dropdown-item
        title="我的医院"
        v-model="hospitalId"
        :options="hospitals"
        @change="changeHos()"
      />
    </van-dropdown-menu>
  </div>
</template>
<script>
import { httpService } from "@/service/httpService.js";
export default {
  data() {
    return {
      citys: [],
      hospitals: [],
      cityId: undefined,
      hospitalId: undefined
    };
  },
  methods: {
    changeCity() {
        //修改城市后重新得到当前城市的医院列表 && 更新餐厅列表 && 当前医院id = undefined
      this.queryMyHospitals()
      this.hospitalId = undefined
      let params = {
          cityId: this.cityId
      }
      this.$emit('queryList', params)
    },
    changeHos() {
        // 更新餐厅列表
        let params = {
            cityId: this.cityId,
            hospitalId: this.hospitalId
        }
        this.$emit('queryList', params)
        
    },
    getMyCity() {
      let params = {
        itemType: 5
      };
      httpService.queryMyCity(params).then(res => {
        if (res && res.success) {
          this.citys = res.content.data.map(item => {
            return { ...item, text: item.txt, value: item.pingRegionId };
          });
        }
      });
    },
    queryMyHospitals() {
      let params = {
        itemType: 5,
        cityId: this.cityId
      };
      httpService.queryMyHospitals(params).then(res => {
        if (res && res.success) {
          this.hospitals = res.content.data.map(item => {
            return { ...item, text: item.name, value: item.rowId };
          });
        }
      });
    }
  },
  mounted() {
     this.getMyCity() 
     this.queryMyHospitals()
  }
};
</script>
<style lang="scss" scoped>
</style>
